import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationStackedColumnChartIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "rect",
    {
      x: "64",
      y: "888",
      width: "896",
      height: "72",
      rx: "32",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M160 64C142.327 64 128 78.3269 128 96V293.389C135.274 289.934 143.411 288 152 288H300C308.589 288 316.726 289.934 324 293.389V96C324 78.3269 309.673 64 292 64H160Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M446 192C428.327 192 414 206.327 414 224V421.389C421.274 417.934 429.411 416 438 416H586C594.589 416 602.726 417.934 610 421.389V224C610 206.327 595.673 192 578 192H446Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M732 320C714.327 320 700 334.327 700 352V549.389C707.274 545.934 715.411 544 724 544H872C880.589 544 888.726 545.934 896 549.389V352C896 334.327 881.673 320 864 320H732Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M128 352C128 334.327 142.327 320 160 320H292C309.673 320 324 334.327 324 352V784C324 801.673 309.673 816 292 816H160C142.327 816 128 801.673 128 784V352Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M414 480C414 462.327 428.327 448 446 448H578C595.673 448 610 462.327 610 480V784C610 801.673 595.673 816 578 816H446C428.327 816 414 801.673 414 784V480Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M700 608C700 590.327 714.327 576 732 576H864C881.673 576 896 590.327 896 608V784C896 801.673 881.673 816 864 816H732C714.327 816 700 801.673 700 784V608Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationStackedColumnChartIcon
};
